import { configureStore } from '@reduxjs/toolkit'
import { useDispatch } from 'react-redux'
import { AppConfigReducer } from './app-config'
import { ClaimReservationReducer } from './claim-reservation'

export const STORE_REDUCERS = {
  appConfig: AppConfigReducer,
  claimReservation: ClaimReservationReducer,
}

export const store = configureStore({
  reducer: STORE_REDUCERS,
})

// Infer the `RootState` and `AppDispatch` types from the store itself
export type RootState = ReturnType<typeof store.getState>
// Inferred type: {posts: PostsState, comments: CommentsState, users: UsersState}
export type AppDispatch = typeof store.dispatch

export const useAppDispatch = () => useDispatch<typeof store.dispatch>()
